<template>
  <section>
    <div class="tabs is-boxed">
      <ul>
        <li :class="activeTab === 'active' && 'is-active'">
          <a @click="activeTab = 'active'">
            <span>Tags ({{ tags.length }})</span>
          </a>
        </li>
        <li :class="activeTab === 'archived' && 'is-active'">
          <a @click="activeTab = 'archived'">
            <span>Archived ({{ archivedTags.length }})</span>
          </a>
        </li>
      </ul>
    </div>

    <div v-if="activeTab == 'active'">
      <section class="tags" v-for="tag in tags">
        <Tag
          :key='tag.id'
          :id='tag.id'
          :rubric='tag.rubric'
          :color='tag.color'
          :title='tag.title'
          :owner="tag.owner"
          :groupTag="tag.group_tag"
        />
      </section>
      <section class="mt-4">
        <span @click="addTag(false)" class="button is-large is-warning">Create Tag</span>
        <span @click="addTag(true)" class="button is-large is-warning">Create Rubric Tag</span>
      </section>
    </div>

    <div v-if="activeTab == 'archived'">
      <section class="tags" v-for="tag in archivedTags">
        <Tag
          :key='tag.id'
          :id='tag.id'
          :rubric='tag.rubric'
          :color='tag.color'
          :title='tag.title'
          :owner="tag.owner"
          :groupTag="tag.group_tag"
        />
      </section>
    </div>
  </section>
</template>

<script>

import store from '../store'

import {
  createTag,
} from '../actionTypes'

import Confirm from './Confirm.vue'
import Tag from './Tag.vue'

export default {
  name: 'TagManager',
  components: {
    Confirm,
    Tag,
  },
  data () {
    return {
      loading: true,
      activeTab: 'active'
    }
  },
  async mounted () {
    await store.dispatch('fetchTags')
    this.loading = false
  },
  computed: {
    tags () {
      return store.state.tags.filter(u => !u.archived)
    },
    archivedTags () {
      return store.state.tags.filter(u => u.archived)
    },
    userID () {
      return store.state.user.id
    },
  },
  methods: {
    async addTag (createRubric) {
      const tagTitle = 'Click to edit'
      await store.dispatch(createTag, { title: tagTitle, createRubric })
    },
  },
}
</script>


<style lang="scss" scoped>

.tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// TagManager.vue?01312fb5